<!-- Loader -->
<div *ngIf="loader">
    <div id="global-loader">
        <img src="../../assets/img/loader/state=1.png" class="loader-img" alt="Loader State 1" [style.opacity]="opacity">
    </div>
</div>
<!-- End Loader -->
